<script>
  export default {
    props: ['campaign']
  }
</script>

<template>
  <div class="digital-300x250-preview d-flex flex-column">
    <div class="position-relative">
      <div class="digital-300x250-preview__image-wrapper">
        <img :src="campaign.campaignImages[0].image.url" alt="" class="digital-300x250-preview__image" />
      </div>
      <div class="digital-300x250-preview__logo-wrapper" :style="{ backgroundColor: campaign.advertiser.backgroundColor }">
        <img :src="campaign.logoImage.url" alt="Logo Image" class="digital-300x250-preview__logo-image" />
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center digital-300x250-preview__headline-wrapper h-100">
      <p class="mb-0 digital-300x250-preview__headline">{{ campaign.digitalHeadline }}</p>
      <button class="digital-300x250-preview__button font-size-13" :style="{ backgroundColor: campaign.callToActionBackgroundColor, color: campaign.callToActionTextColor }">{{ campaign.callToActionType.description }}</button>
    </div>
  </div>
</template>